module.exports = __webpack_public_path__ + "img/9788949120775.65c82b92.jpg";